import { memo } from 'react';
import { View, Text } from 'react-native';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentCase } from '../cases/selector';

import MedRecruiterProviderHome from '../medRecruiter/provider_home';

export default memo(function (props) {
  const currentCaseObj = useSelector((state) => getCurrentCase(state));
  return (
    <MedRecruiterProviderHome screenVisible={props.screenVisible} currentCaseObj={currentCaseObj} />
  );
});
